import React from 'react'
import { Table } from 'antd'

import type { LntTableProps, LntTableFC } from './types'

export const LntTable: LntTableFC = <TRecord extends object>(props: LntTableProps<TRecord>): JSX.Element => {
  const { children, ...restProps } = props

  return <Table<TRecord> { ...restProps }>{ children }</Table>
}
